import wp from '@/api/wp'

const all = async ({ commit }) => {
  commit('setLoading', true)

  let list = await wp.groups().page(1).perPage(100)

  list.forEach(item => item.active = false)

  commit('setList', list)

  commit('setLoading', false)
}

const turnTag = ({ commit }, clickedTag) => {
  commit('turnTag', clickedTag)
}

export default {
  all,
  turnTag,
}
